
define('text!views/pages/iddqdLight.html',[],function () { return '<div class="page">\n\n    <div class="pad">Settings made here will be reflected when you refresh the page.</div>\n\n    <div class="pad">\n        <button class="full-width" data-bind="css: {green: showDisabledGames}, click: showDisabledGames.toggles()">Show Disabled Games</button>\n    </div>\n\n</div>\n';});

